(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('CardSearch', CardSearch);

  CardSearch.$inject = ['$resource', 'API_URI'];

  function CardSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/cards/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
